import { useState } from "react";
import logo from "../assets/image/logo/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { useAuth } from "../contexts/AuthContext";

function Header() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated, accountType, logout } = useAuth();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = async () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
    await logout();
    navigate("/");
  };

  const handleLogoClick = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
    navigate("/");
  };

  return (
    <>
      {/* Desktop Header */}
      <header className="header d-none d-lg-block">
        <div className="header_section">
          <div className="logo">
            <Link to="/" onClick={handleLogoClick}>
              <img src={logo} alt="" className="img-fluid" />
            </Link>
          </div>
          <div className="header_menu">
            <ul>
              <li>
                <Link to="/cohorts">Cohorts</Link>
              </li> 
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/private-courses">Courses</Link>
              </li>
              <li>
                <Link to="/faqs">FAQs</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>
          <div className="header_buttons">
            {isAuthenticated ? (
              <div className="d-flex align-items-center gap-3">
                <button
                  onClick={handleLogout}
                  className="btn-process-button--primary signup-btn"
                >
                  Logout
                </button>
                <Link
                  to={accountType === "organization" ? "/organization/dashboard" : "/dashboard"}
                  className="btn-process-button--primary signup-btn"
                >
                  Dashboard
                </Link>
                
              </div>
            ) : (
              <Link
                to="/login"
                className="btn-process-button--primary signup-btn"
              >
                Login
              </Link>
            )}
          </div>
        </div>
      </header>

      {/* Mobile Header */}
      <header className="header-mobile d-block d-lg-none">
        <div className="header_section_mobile">
          <div className="logo">
            <Link to="/" onClick={handleLogoClick}>
              <img src={logo} alt="" className="img-fluid" />
            </Link>
          </div>
          <div className="menu-icon" onClick={toggleMenu}>
            {isMenuOpen ? (
              <FaTimes className="primary-color" />
            ) : (
              <FaBars className="primary-color" />
            )}
          </div>
        </div>
        <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
          <ul>
            <li>
              <Link to="/cohorts" onClick={toggleMenu}>
                Cohorts
              </Link>
            </li> 
            <li>
              <Link to="/about" onClick={toggleMenu}>
                About
              </Link>
            </li>
            <li>
              <Link to="/faqs" onClick={toggleMenu}>
                FAQs
              </Link>
            </li>
            <li>
              <Link to="/private-courses" onClick={toggleMenu}>
                Courses
              </Link>
            </li>
            <li>
              <Link to="/contact" onClick={toggleMenu}>
                Contact
              </Link>
            </li>

            {isAuthenticated ? (
              <>
                <li className="mb-2">
                  <Link
                    to={accountType === "organization" ? "/organization/dashboard" : "/dashboard"}
                    className="btn-theme primary-btn signup-btn text-center text-white d-block"
                    onClick={toggleMenu}
                  >
                    Dashboard
                  </Link>
                </li>
                <li>
                  <button
                    onClick={handleLogout}
                    className="w-100 text-center text-white"
                    style={{
                      borderRadius: "25px",
                      padding: "12px",
                      backgroundColor: "#dc3545",
                      border: "none",
                      fontWeight: "600",
                      display: "block"
                    }}
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <li>
                <Link to="/login" className="btn-theme primary-btn signup-btn" onClick={toggleMenu}>
                  Login
                </Link>
              </li>
            )}
          </ul>
        </div>
      </header>
    </>
  );
}

export default Header;
